<template>
  <div class="privacy-policy">
    <div class="title">Privacy Policy</div>
    <div class="content">
      <ul>
        <li>Tiny Expense Manager is built with a privacy first approach.</li>
        <li>We do not store any data on our servers.</li>
        <li>All data generated by the app is stored directly in the user's device.</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.privacy-policy {
  margin-left: 1rem;
  margin-top: 1rem;
}
</style>